import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { Button } from "../../atoms/Button";

export type AnalyticsCardValueProps = ComponentProps<typeof Button>;

/** A large centered value display, e.g. `<AnalyticsCard><AnalyticsCard.Value onClick={...}>76</AnalyticsCard.Value></AnalyticsCard>`. */
export const AnalyticsCardValue = ({ className, ...props }: AnalyticsCardValueProps) => (
  <Button
    variant="outline"
    color="primary"
    size="lg"
    className={cn(
      "h-auto rounded-[calc(var(--radius)-2px)] border-transparent px-8 py-4 text-2xl font-semibold tabular-nums shadow-none hover:bg-transparent hover:text-foreground",
      className
    )}
    {...props}
  />
);
